import { VueModule } from '@Foundation/utilities';
import Newsletter from './code/Scripts/components/newsletter';

export default VueModule({
  components: {
    Newsletter
  }
});
